import React, { createContext, useContext, useState, useCallback } from "react";

export const ConnectionModes = {
    CLOUD: "cloud",
    MANUAL: "manual",
    ENV: "env",
  };
  

const ConnectionContext = createContext();

export const ConnectionProvider = ({ children }) => {
  const [connection, setConnection] = useState({
    wsUrl: "",
    token: "",
    shouldConnect: false,
    mode: "manual",
  });

  const connect = useCallback(async (mode) => {
    // Stub: Replace with actual connection logic (token generation, etc.)
    setConnection({ wsUrl: "wss://newsbuddy-hj7mrmxi.livekit.cloud", token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3NDExMDY5NzksImlzcyI6IkFQSUhuVjZkczk4WlFNZCIsIm5iZiI6MTc0MTA5OTc3OSwic3ViIjoicXVpY2tzdGFydCB1c2VyIDN5bGw2ayIsInZpZGVvIjp7ImNhblB1Ymxpc2giOnRydWUsImNhblB1Ymxpc2hEYXRhIjp0cnVlLCJjYW5TdWJzY3JpYmUiOnRydWUsInJvb20iOiJxdWlja3N0YXJ0IHJvb20iLCJyb29tSm9pbiI6dHJ1ZX19.a1IGwNk0ff7HoIfEZN3CarSCWN2VTE121TRd0kJ7aGE", shouldConnect: true, mode });
  }, []);

  const disconnect = useCallback(async () => {
    setConnection((prev) => ({ ...prev, shouldConnect: false }));
  }, []);

  return (
    <ConnectionContext.Provider value={{ ...connection, connect, disconnect }}>
      {children}
    </ConnectionContext.Provider>
  );
};

export const useConnection = () => useContext(ConnectionContext);
